import React, { Component } from 'react';
import debounce from '../../../Utils/Reactive';
// import Draggable from 'react-draggable';
import BotIcon from '../../../../assets/imgs/bot.svg';


interface IProps {
    isBotVisible,
    logoImagePath,
    returnSaneURL,
    showBot,
    isMobileApp,
    isNetBanking,
    isBotIconVisible
}

// interface IState {

//     isBotIconVisible: boolean


// }
class Icon extends Component<IProps> {
    constructor(props) {
        super(props);

    
    }

    
    handleOnDragStart(ev){
        ev.dataTransfer.effectAllowed = "move";
        ev.dataTransfer.setData("text/plain", ev.target.id);
    }

    handleDrag(ev){
        ev.dataTransfer.effectAllowed = "move";
    }


    makeBotIconDraggable(){
        let body = document.body;
        body.addEventListener("dragover" , (ev) => {
            if (ev.preventDefault) {
                ev.preventDefault(); // Necessary. Allows us to drop.
            }
            ev.dataTransfer.dropEffect = "move";
            return false;
        });

        body.addEventListener("drop", (ev) => {
            var draggedElemsID = ev.dataTransfer.getData("text/plain");
            if(draggedElemsID !== "sf-bot-icon"){
                return;
            }
            var draggedElem = document.getElementById(draggedElemsID);
            let cordinates = { 
                x : ev.clientX,
                y : ev.clientY
            }
            draggedElem.style.left =  cordinates.x + "px";
            draggedElem.style.top = cordinates.y + "px";
        });

    }

    // setBotIconVisibility(flag = true){
    //     this.setState({
    //         isBotIconVisible:flag
          
    //     })
    // }

    componentDidMount(){
        //Add this based on configs
        this.makeBotIconDraggable();
      //  window['setBotIconVisibility'] = this.setBotIconVisibility.bind(this)


    }

  

    render() {
        return (
            <React.Fragment>
            {/* <Draggable> */}

            <div style={{visibility:this.props.isBotIconVisible?"visible":"hidden"}}>
                    <div className={this.props.isMobileApp?`sf-bot-icon handle`:`sf-bot-icon handle vert-move`} 
                        id="sf-bot-icon"
                        style={{
                            display : this.props.isBotVisible? "none":"block",
                            //display:"none",
                            // background:'url("'+this.props.returnSaneURL(this.props.logoImagePath)+'")',
                            background:"url(" + { BotIcon } + ")",
                            backgroundRepeat: "no-repeat", backgroundPosition: "center",
                            backgroundSize:"contain",
                        }}
                        draggable={true}
                        onClick={this.props.showBot}
                        onDragStart={this.handleOnDragStart.bind(this)}
                        onDrag={this.handleDrag.bind(this)}
                    >
                    </div>
                    </div>
            {/* </Draggable> */}
            </React.Fragment>
        );
    }
}

export default Icon;